module.exports = __webpack_public_path__ + "static/img/91BM-024-OliverNg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-024-OliverNg.jpg
// module id = e5Zz
// module chunks = 0